<div class="loader-container">
<!--    <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>-->
    <img src="/site/DesktopModules/CargaMasivaDP/wwwroot/assets/img/cargando.gif" alt="Cargando...">
    <!--<img src="/DesktopModules/CargaMasivaDP/wwwroot/assets/img/cargando.gif" alt="Cargando...">-->
</div>